export default {"src":"/_next/static/media/Shortlisted.4cb14ee4.svg","height":272,"width":253,"blurWidth":0,"blurHeight":0};